import { Component, Input } from '@angular/core';
import { DictionaryDropdownInput } from './dropdown-input';

@Component({
  selector: 'libero-dictionary-dropdown',
  templateUrl: './dictionary-dropdown.component.html',
  styleUrls: ['./dictionary-dropdown.component.scss'],
  standalone: false
})
export class DictionaryDropdownComponent {
  @Input() public dropdownInput!: DictionaryDropdownInput;

  public toggled = false;
}
